/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
import { DataSTag, Sel } from '#~/stag/index.js';
import { Button as DSButton } from '@studio/design-system/button';
import { motion } from '@studio/design-system/motion';
import { clsx } from 'cn';
import type { ReactNode } from 'react';

interface Props {
  selectedTab: 'monthly' | 'yearly';
  setSelectedTab: (tab: 'monthly' | 'yearly') => void;
}

/* eslint-disable jsdoc/require-jsdoc */
export const Tabs = ({ selectedTab, setSelectedTab }: Props) => (
  <div className='flex justify-center gap-x-8 rounded-8 bg-base-200 p-8'>
    <Button
      tag='frequency-monthly'
      onClick={() => setSelectedTab('monthly')}
      selected={selectedTab === 'monthly'}
    >
      Monthly
    </Button>
    <Button
      tag='frequency-yearly'
      onClick={() => setSelectedTab('yearly')}
      selected={selectedTab === 'yearly'}
    >
      Yearly
      <span className='ml-8 rounded-full bg-base-100 px-8 py-4 text-primary'>
        Get a month free!
      </span>
    </Button>
  </div>
);

const Button = ({
  children,
  onClick,
  selected,
  tag
}: {
  children: ReactNode;
  onClick: () => void;
  selected: boolean;
  tag: string;
}) => (
  <DSButton
    {...DataSTag(Sel.AccountSettings, tag)}
    className={clsx('relative p-10 transition-colors duration-250', {
      'text-secondary': !selected
    })}
    onClick={onClick}
    type='button'
  >
    {!!selected && (
      <motion.span
        className='absolute inset-0 rounded-8 bg-base-100'
        layoutId='price-selected-tab'
        transition={{
          duration: 0.2,
          type: 'spring'
        }}
      />
    )}

    <span className='relative z-10'>{children}</span>
  </DSButton>
);
